import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Share, ENVIRONMENT, Environment, HttpShare, TcpShare } from '@netfoundry-ui/shared/model';
import { result, toLower } from 'lodash';
import { catchError, delay } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import {
    GetOption,
    HateoasResourceOperation,
    HttpMethod,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { take, tap } from 'rxjs/operators';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class ShareService extends HateoasResourceOperation<Share> {
    apiUrl;
    appsUrl;
    model: Share | null = null;
    networkPricing = 199.0;
    regionPricing = [{ region: null, price: 0.2, rate: 'GB' }];
    lastPageCount = 0;
    lastTotalCount = 0;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };

    constructor(
        private logger: LoggerService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(Share);
        this.apiUrl = this.environment.frontdoorURL;

    }


    public findShares(options?: PagedGetOption): Promise<Share[]> {
        return super
            .getPage({ ...ShareService.defaultHttpAccept, ...options })
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((shares) => (shares ? shares.resources : []));
    }


    public getSharePage(
    frontdoorId?: string,
    options?: PagedGetOption
    ): Promise<Share[]> {
    const headers = new HttpHeaders().set('Accept', 'application/hal+json');

    let params = new HttpParams().set('sort', 'createdAt,DESC');

    if(options) {
        if (options.pageParams) {
        Object.keys(options.pageParams).forEach(key => {
            const value = options.pageParams[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
            params = params.append(key, String(value));
            }
        });
        }

    // Handle the nested params object
        if (options.params) {
        Object.keys(options.params).forEach(key => {
            const value = options.params[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
            params = params.append(key, String(value));
            }
        });
    }
}


  return this.http
    .get<any>(`${this.apiUrl}/${frontdoorId}/shares`, {
      headers,
      params,
    })
    .pipe(
      tap((val) => {
        this.lastPageCount = val.page.totalPages;
        this.lastTotalCount = val.page.totalElements;
      })
    )
    .toPromise()
}




    public create(frontdoorId: string, model, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/shares`
        return this.http
        .post(fullpath, model)
    }

        public createhttp(frontdoorId: string, model) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/http-shares`
        return this.http
        .post(fullpath, model)
    }

        public createtcp(frontdoorId: string, model) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/tcp-shares`
        return this.http
        .post(fullpath, model)
    }

        public getHttpShare(frontdoorId: string, id: string) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/http-shares/${id}`
        return this.http
        .get(fullpath)
    }

        public getTcpShare(frontdoorId: string, id: string) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/tcp-shares/${id}`
        return this.http
        .get(fullpath)
    }

        public updatehttp(frontdoorId: string, model, id: string,) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/http-shares/${id}`
        return this.http
        .put(fullpath, model)
    }

        public updatetcp(frontdoorId: string, model, id: string,) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/tcp-shares/${id}`
        return this.http
        .put(fullpath, model)
    }

    public delete(frontdoorId: string, id: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/shares/${id}`
        return this.http
        .delete(fullpath)
    }

    public deleteHTTP(frontdoorId: string, id: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/http-shares/${id}`
        return this.http
        .delete(fullpath)
    }

    public deleteTCP(frontdoorId: string, id: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/tcp-shares/${id}`
        return this.http
        .delete(fullpath)
    }


    public getShares(frontdoorId: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/shares`
        return this.http
        .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }

    public getHttpShares(id: string, options?: PagedGetOption): Promise<HttpShare[]> {
              const headers = new HttpHeaders().set('Accept', 'application/hal+json');

              let params = new HttpParams().set('sort', 'createdAt,DESC');
            if(options) {
        if (options.pageParams) {
          Object.keys(options.pageParams).forEach(key => {
            const value = options.pageParams[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });
        }

       // Handle the nested params object
        if (options.params) {
          Object.keys(options.params).forEach(key => {
            const value = options.params[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });

      }
    }
            return this.http
                    .get<any>(`${this.apiUrl}/v2/${id}/http-shares`, {
                        headers,
                        params,
                        })
                .pipe(
                    tap((val) => {
                        this.lastPageCount = val.page.totalPages;
                        this.lastTotalCount = val.page.totalElements;
                    })
                )
                .toPromise()
        }

    public getTcpShares(id: string, options?: PagedGetOption): Promise<TcpShare[]> {
              const headers = new HttpHeaders().set('Accept', 'application/hal+json');

              let params = new HttpParams().set('sort', 'createdAt,DESC');
            if(options) {
        if (options.pageParams) {
          Object.keys(options.pageParams).forEach(key => {
            const value = options.pageParams[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });
        }

       // Handle the nested params object
        if (options.params) {
          Object.keys(options.params).forEach(key => {
            const value = options.params[key]; // <-- Corrected
            if (value !== undefined && value !== null) {
              params = params.append(key, String(value));
            }
          });

      }
    }
            return this.http
                    .get<any>(`${this.apiUrl}/v2/${id}/tcp-shares`, {
                        headers,
                        params,
                        })
                .pipe(
                    tap((val) => {
                        this.lastPageCount = val.page.totalPages;
                        this.lastTotalCount = val.page.totalElements;
                    })
                )
                .toPromise()
        }


    public getSparklinesByShare(frontdoorId: string, identifier: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const param = `shares=${encodeURIComponent(identifier)}`;
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/sparklines?${param}`
        return this.http
        .get(fullpath, {
        headers: { Accept: 'application/hal+json' }})
    }

    public setModel(data: Share) {
        this.model = data;
    }


    getModel(): Share | null {
        return this.model;
    }



    /**
     * @param path
     * @param data
     */
    public post(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.post(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * @param path
     * @param data
     */
    public put(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.put(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * Generic GETter
     */

    public get(path: string) {
        const fullpath = `${this.apiUrl}${path}`;

        return this.http.get(fullpath, { headers: this.setHeaders() });
    }

    /**
     * Return headers
     */
    private setHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

                  return headers.append('Content-Type', 'application/json');
    }

        /**
     * Generic error handler for bad requests
     */
        protected handleError(scope: any, error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                scope.logger.error('Feature Service error occurred:', error.error);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
            }
            scope.lastErrorSource.next(error);
            return observableThrowError(error);
        }
}
